import { createElement, forwardRef } from "react";
import { m, useReducedMotion } from "framer-motion";
import { staggerContainer, viewport } from "../../../utils/motionVariants";
import { getMotionComponent, resolveTag } from "./motionPrimitives";

/**
 * Single viewport observer + staggered children.
 * Prefer this over multiple MotionReveal siblings in the same block.
 */
const MotionStagger = forwardRef(function MotionStagger(
  { as = "div", className, children, viewport: viewportProp, immediate = false, ...props },
  ref
) {
  const reduceMotion = useReducedMotion();
  const tag = resolveTag(as);

  if (reduceMotion) {
    return createElement(tag, { ref, className, ...props }, children);
  }

  const Component = getMotionComponent(m, tag);
  const resolvedViewport = viewportProp ?? viewport;

  return createElement(
    Component,
    {
      ref,
      initial: "hidden",
      ...(immediate
        ? { animate: "visible" }
        : { whileInView: "visible", viewport: resolvedViewport }),
      variants: staggerContainer,
      className,
      ...props,
    },
    children
  );
});

MotionStagger.displayName = "MotionStagger";

export default MotionStagger;
